import React, { Suspense } from 'react';
import { TermsAndConditionComponent } from './terms-and-conditions.component';

export const TermsAndConditionComponentLazy = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <TermsAndConditionComponent {...props} />
  </Suspense>
);
